import axios from 'axios';
import { useQuery } from 'react-query';
import { RoleDto } from '../../../codegen/Swagger';
import { getApi } from '../../../config/SwaggerApi';
import { ModuleDto } from '../../../swagger';
import { configQueryReactSimpleRequestSecurity } from '../config';
const fetchRolesByModuleId = (moduleId: ModuleDto) => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const promise = getApi()
        .security.securityGetRolesByModuleIdGet(
            { ModuleId: moduleId.moduleId },
            {
                cancelToken: source.token,
            },
        )
        .then((response) => response.data);
    (promise as any).cancel = () => {
        source.cancel('Query was cancelled by React Query');
    };
    return promise;
};
const useRoleByModuleId = (module: any) => {
    const modulesQuery = useQuery<RoleDto[], Error>(
        ['roles-module-', module?.moduleId],
        () => fetchRolesByModuleId(module),
        {
            ...configQueryReactSimpleRequestSecurity,
            enabled: module != null,
        },
    );

    return modulesQuery;
};

export default useRoleByModuleId;
